<template>
  <v-container
    class="pt-4"
    fluid
  >
    <v-row>
      <v-col
        :cols="currentSociety === undefined ? '12' : '4'"
        class="list-overflow"
      >
        <v-list>
          <v-list-item-group v-model="currentSociety">
            <v-list-item
              v-for="society in socData"
              :key="society.key"
            >
              <v-list-item-title>{{ society.name }}</v-list-item-title>
              <v-list-item-action>
                <v-icon>mdi-pencil</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col
        v-if="currentSociety !== undefined"
        cols="4"
      >
        <v-treeview
          v-model="currentPlayer"
          selectable
          open-all
          :items="allPlayer"
          item-text="name"
          item-key="id_plyr"
          return-object
        />
      </v-col>
      <v-col
        v-if="currentPlayer.length !== 0"
        cols="4"
      >
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="socData[currentSociety].name"
                :rules="[rules.required]"
                :label="$t('akito.account-name')"
                readonly
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="socData[currentSociety].sub_type"
                :items="$t('profile.subscriptions')"
                :label="$t('profile.sections.account.sub')"
                readonly
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="socData[currentSociety].sub_renewal"
                :rules="[rules.required]"
                :label="$t('akito.sub-renewal')"
                readonly
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-left="60"
                transition="scale-transition"
                offset-y
                dense
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="dateFormat(dtrenewal)"
                    :label="$t('akito.date-expire')"
                    readonly
                    v-bind="attrs"
                    dense
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dtrenewal"
                  first-day-of-week="1"
                  scrollable
                  no-title
                  locale="fr-fr"
                  @input="menu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-btn
                color="primary"
                :disabled="disableButton"
                @click="updateLicense(socData[currentSociety])"
              >
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.update") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { ProfileAccessConnector } from "../../Database/ProfileAccessConnector.js";
import { ProfileUserConnector } from "../../Database/ProfileUserConnector.js";
import { ProfileSocietyConnector } from "../../Database/ProfileSocietyConnector.js";

// Libs
const moment = require("moment");

export default {
  components: {
    //
  },
  data() {
    return {
      accessConnector: new ProfileAccessConnector(this.$store.state.user),
      userConnector: new ProfileUserConnector(this.$store.state.user),
      societyConnector: new ProfileSocietyConnector(this.$store.state.user),
      currentSociety: undefined,
      currentPlayer: [],
      usersData: [],
      accessesData: [],
      disableButton: false,
      show: false,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
        min: (v) => v.length >= 8 || this.$t("field.min-8"),
        regex: (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t("profile.sections.user.mail"),
      },
      socData: [],
      menu: false,
      fullUser: [],
      fullPlayer: [],
      allPlayer: [],
      dtrenewal: "",
    };
  },
  watch: {
    currentSociety: function (val) {
      let tempo = [];

      if (val !== undefined) {
        this.fullPlayer.forEach((element) => {
          if (element.soc_id == this.socData[val].id_soc) {
            tempo.push(element);
          }
        });
        tempo = [{ name: "Tous", id_plyr: "0", children: tempo }];
      }
      this.allPlayer = tempo;
    },
  },
  created() {
    this.getListAccess();
    this.getPlayerForAll();
    this.getSociety();
  },
  methods: {
    getDate(date) {
      if (date == "0000-00-00") {
        this.socData[this.currentSociety].sub_renewal = moment(moment().toDate("YYYY-MM-DD")).format("YYYY-MM-DD");
      }
      return true;
    },
    dateFormat(date) {
      if (date != "") {
        return moment(date).format("DD-MM-YYYY");
      } else {
        return "";
      }
    },
    getPlayerForAll() {
      this.societyConnector.getPlayerForAll().then((response) => {
        // TODO: format in db server
        this.allPlayer = response.map((data) => {
          return {
            id_plyr: data.id_plyr,
            name: data.name,
            soc_id: data.soc_id,
          };
        });

        this.fullPlayer = this.allPlayer;
      });
    },
    getSociety() {
      this.societyConnector.getSoc().then((response) => {
        this.socData = response;

        this.socData.forEach((element, index) => {
          if (element.sub_renewal == "Invalid date") {
            element.sub_renewal = "00-00-0000";
          }

          if (element.id_soc == 0) {
            this.socData.splice(index);
          }
        });
      });
    },
    getListAccess() {
      this.accessConnector.getListAccess().then((response) => {
        // TODO: format in db server
        this.accessesData = response.map((data) => {
          return {
            value: data.id_right,
            text: data.name,
          };
        });
      });
    },
    getUsersData() {
      this.userConnector.getUsersData().then((users) => {
        // TODO: format in db server
        this.usersData = users.map((data) => {
          return {
            id_usr: data.id_usr,
            login: data.login,
            password: "",
            name: data.lastname,
            firstname: data.firstname,
            phone: data.phone,
            access: data.right_id,
            soc_id: data.soc_id,
          };
        });

        this.fullUser = this.usersData;
      });
    },
    createUser() {
      if (
        this.usersData[this.currentSociety].login.length >= 6 &&
        this.usersData[this.currentSociety].password.length >= 8
      ) {
        this.disableButton = true;

        this.userConnector
          .insertUserData(this.usersData[this.currentSociety])
          .then(() => {
            this.usersData[this.currentSociety].password = "";
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
    updateLicense(soc) {
      // TODO: WHY NOT THE SAME FORMAT BETWEEN THE 2 MOMENT DECLARATIONS
      soc.sub_renewal = moment(moment().toDate("YYYY-MM-DD")).format("YYYY-MM-DD");
      this.societyConnector.updateLicense(this.currentPlayer, soc, this.dtrenewal);
      soc.sub_renewal = moment(moment().toDate("YYYY-MM-DD")).format("DD-MM-YYYY");
      this.dtrenewal = "";
    },
  },
};
</script>

<style></style>
